export class DocumentRequestModel {
    type: string;
    ownerId: string;
    ownerType: string;
    file: string;
}

export class DocumentResponseModel {
    id: string;
    location: string;
    ownerId: string;
    ownerType: string;
    type: string;
}

export class OrderDocumentMappingRequest {
    documentIds: string[];
    kycDocumentPurpose: string;
    isKycDocument: boolean;
}



// WEBPACK FOOTER //
// ./src/app/_models/documents/DocumentRequestModel.ts